import { request } from '@/api/client';
import type { LoginRequest, RegisterRequest, AuthResponse } from '@/types/auth';
import type { User } from '@/types/user';

export function login(data: LoginRequest): Promise<AuthResponse> {
  return request<AuthResponse>('/auth/login', {
    method: 'POST',
    body: data,
  });
}

export function register(data: RegisterRequest): Promise<AuthResponse> {
  return request<AuthResponse>('/auth/register', {
    method: 'POST',
    body: data,
  });
}

export function getMe(): Promise<User> {
  return request<User>('/auth/me');
}

export function refreshToken(rt: string): Promise<AuthResponse> {
  return request<AuthResponse>('/auth/refresh', { method: 'POST', body: { refreshToken: rt }, skipAuth: true });
}

export function updateName(name: string): Promise<User> {
  return request<User>('/auth/me', { method: 'PUT', body: { name } });
}

export function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  return request<void>('/auth/password', { method: 'PUT', body: { oldPassword, newPassword } });
}

export function bindPlatform(platform: 'dingtalk' | 'feishu' | 'wecom', account: string): Promise<User> {
  return request<User>(`/auth/bind/${platform}`, { method: 'POST', body: { account } });
}

export function unbindPlatform(platform: 'dingtalk' | 'feishu' | 'wecom'): Promise<User> {
  return request<User>(`/auth/bind/${platform}`, { method: 'DELETE' });
}

export interface WecomConfig {
  corpId: string;
  agentId: string;
  redirectUri: string;
  enabled: boolean;
}

export function getWecomConfig(): Promise<WecomConfig> {
  return request<WecomConfig>('/auth/wecom/config', { skipAuth: true });
}

export function wecomLogin(code: string, state: string): Promise<AuthResponse> {
  return request<AuthResponse>('/auth/wecom/login', {
    method: 'POST',
    body: { code, state },
    skipAuth: true,
  });
}

export function wecomBind(code: string): Promise<User> {
  return request<User>('/auth/wecom/bind', { method: 'POST', body: { code } });
}